exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wf_divider {\n  background-color: #B3B5B8;\n  height: 0.025rem;\n  margin: 0 0 1.25rem 0;\n}\n", ""]);

